module.exports = __webpack_public_path__ + "img/brand_website.235b1f35.svg";